import type { AIResourceRef } from "@k8s-dashboard/contracts";
import { refPath } from "@/components/drill";

/**
 * 참조를 **내부 라우트**로 바꿉니다. (ADR 0026 · ADR 0027)
 *
 * 계약 검증(isSafeResourceRef)을 이미 통과한 값만 여기 옵니다. 그래도 경로는
 * 기존 refPath 하나로만 만듭니다 — 링크 만드는 규칙이 두 벌이 되는 순간 한쪽만
 * 인코딩을 빠뜨리는 날이 옵니다. Action Card도 같은 이유로 이 함수를 씁니다.
 *
 * 클러스터는 URL에 싣지 않습니다 — Observer는 단일 클러스터 배포이고 클러스터는 앱 상태입니다. (#94)
 * namespace·종류·UID는 참조의 것을 씁니다. lang·range 같은 나머지 질의는 그대로 둡니다.
 */
export function referenceHref(reference: AIResourceRef, search: string): string {
  if (reference.kind === "pod") {
    return refPath({ namespace: reference.namespace, podName: reference.name, podUid: reference.uid }, search);
  }
  return refPath(
    {
      namespace: reference.namespace,
      workloadName: reference.name,
      workloadKind: (reference.workloadKind ?? "Deployment") as "Deployment",
    },
    search,
  );
}
